import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { Errors, UserService } from '../../core';
import { ApiService } from '@common-lib';
import { ToasterService } from 'angular2-toaster';

@Component({
  selector: 'app-restore-password',
  templateUrl: './restore-password.component.html',
  styleUrls: ['./restore-password.component.scss']
})
export class RestorePasswordComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private api: ApiService,
    private toasterService: ToasterService
  ) { }

  title = '';

  isSubmitting = false;

  restore = {
    token: '',
    password: '',
    confirm: '',
  };


  ngOnInit() {
    this.restore.token = this.route.snapshot.queryParams.token;
  }

  submitForm() {
    this.api.post('/auth/restore', this.restore).subscribe(
      res => {
        let toast = {
          type: 'success',
          title: '',
          body: 'Password has been changed',
          onHideCallback: () => this.router.navigate(['/'])
        };
        this.toasterService.pop(toast);
      },
      err => {
        this.toasterService.pop('error', 'Error', err.message);
      }
    );
  }


}



// WEBPACK FOOTER //
// ./src/app/pages/restore-password/restore-password.component.ts